/**
 * Google Maps Loader Service
 *
 * Handles Google Maps API initialization and loading.
 * This is the core service that must be initialized before using any Google Maps features.
 *
 * Peer Dependencies:
 * - @sparefoot/google-maps (or compatible Google Maps loader)
 *
 * Environment Variables:
 * - Google Maps API key should be passed via initializeGoogle({ key })
 */
import GoogleMapsLoader from "@sparefoot/google-maps";

let googleLoadPromise;

/**
 * Initialize Google Maps with API key
 * @param {Object} options
 * @param {string} options.key - Google Maps API key
 */
export function initializeGoogle({ key }) {
	GoogleMapsLoader.KEY = key;
	GoogleMapsLoader.LIBRARIES = ["places"];
}

/**
 * Load the Google Maps API
 * @returns {Promise<google>} Promise that resolves to the google object
 */
export function loadGoogle() {
	if (typeof globalThis.window !== "undefined" && !googleLoadPromise) {
		googleLoadPromise = new Promise((resolve) => {
			GoogleMapsLoader.load((google) => resolve(google));
		});
	}
	return googleLoadPromise;
}

/**
 * Unload Google Maps (useful for testing)
 */
export function unloadGoogle() {
	googleLoadPromise = undefined;
}

/**
 * Get the Google Maps load promise
 * @returns {Promise<google>|undefined}
 */
export function getGoogleLoadPromise() {
	return googleLoadPromise;
}
